import { useTranslation } from "react-i18next";
import { COUNTRIES, AVAILABLE_LANGS, FEATURE_MULTI_LANG, FEATURE_INTERNATIONAL } from "@/lib/i18n";

export default function LangCountrySelector({ compact = false }) {
  const { i18n } = useTranslation();

  // MVP Phase 1: aucun sélecteur (FR + France only)
  if (!FEATURE_MULTI_LANG && !FEATURE_INTERNATIONAL) return null;

  const LABELS = { fr: "FR", en: "EN", ar: "AR" };
  return (
    <div className={`flex items-center gap-1 ${compact ? "text-xs" : "text-sm"}`}>
      {FEATURE_MULTI_LANG && AVAILABLE_LANGS.map((code) => (
        <button
          key={code}
          onClick={() => i18n.changeLanguage(code)}
          data-testid={`lang-${code}`}
          className={`px-2 py-1 rounded font-bold transition ${
            i18n.language === code ? "bg-[#618DB8] text-white" : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          {LABELS[code]}
        </button>
      ))}
      {FEATURE_INTERNATIONAL && (
        <div className="hidden sm:flex items-center gap-0.5 ms-2 ps-2 border-s border-slate-200">
          {COUNTRIES.map((c) => (
            <span key={c.code} title={c.name} className="text-base px-0.5">
              {c.flag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
